<template>
  <!--Start Banners Sliders--->
  <section class="section-banner header-space px-0">
    <slick v-if="Popups.length > 0" ref="bannerslider" :options="bannerSlider">
      <div v-for="(data, index) in Popups" :key="index">
        <div class="banner-img">
          <div>
            <a
              :href="data.pop_url"
              :style="data.pop_url ? 'cursor:pointer;' : 'pointer-events:none;'"
            >
              <img :src="IMAGEURL + data.pop_image" class="img-fluid" />
            </a>
          </div>
        </div>
      </div>
    </slick>
  </section>
  <!--End Banners Sliders--->
</template>
<script>
import { IMAGEURL } from "@/config";

export default {
  props: {
    Popups: Array,
  },
  beforeMount() {
    // this.hideLoading();
  },
  data() {
    return {
      IMAGEURL,
      bannerSlider: {
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        dots: true,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
      },
    };
  },
  computed: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },

  methods: {},
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/partials/FnbAdSlider.vue